<div class="full-height flex-column">
  <app-custom-settings-dialog-header [entityTranslationKey]="SCHEDULE_TRANSLATION_KEY" [menuItems]="[generalTab]" [canShowSave]="false" (cancel)="navigateBack()" />
  <form class="p-48 b-neutral-950 flex-grow" [formGroup]="scheduleForm">
    <div class="flex gap-64">
      <div class="left-side flex-column gap-8">
        <div class="radio-selection flex-column">
          <div class="title">{{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.START_OF_THE_YEAR' | bmsTranslate }}</div>
          <div class="radio-buttons">
            <mat-radio-group formControlName="calendarFormat" class="flex-column gap-8 pt-8 pb-8">
              @for (item of calenderFormats; track $index) {
                <mat-radio-button [value]="item">
                  {{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.' + item | bmsTranslate }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
        <div class="week-start-day">
          <mat-form-field class="full-width">
            <mat-label>{{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.START_OF_THE_WEEK' | bmsTranslate }}</mat-label>
            <mat-select disableOptionCentering panelClass="bms-theme" formControlName="startOfWeek">
              @for (item of startOfWeekFormats; track $index) {
                <mat-option [value]="item"> {{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.WEEK_DAYS.' + item | bmsTranslate }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="radio-selection flex-column">
          <div class="title">{{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.START_OF_THE_DAY' | bmsTranslate }}</div>
          <div class="radio-buttons">
            <mat-radio-group formControlName="startOfDay" class="flex-column gap-8 pt-8 pb-8">
              @for (item of startOfDayFormats; track $index) {
                <mat-radio-button [value]="item">
                  {{ 'CALENDAR.SCHEDULE.CUSTOM_SETTINGS.' + item | bmsTranslate }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="right-side flex-1"></div>
    </div>
  </form>
</div>
